export default __webpack_public_path__ + "7056c19e67bf19a18dd8fc3969481d6c.svg";